export type NavigationGroup = "pages" | "collections" | "products" | "articles";

export const STANDALONE_GROUP = "";

export interface NavigationItem {
  title: string;
  path: string;
  group: NavigationGroup | typeof STANDALONE_GROUP;
}

export interface GroupState {
  items: NavigationItem[];
  endCursor: string | null;
  hasMore: boolean;
}

export const GROUP_LABELS: Record<NavigationGroup, string> = {
  pages: "Pages",
  collections: "Collections",
  products: "Products",
  articles: "Blog Posts",
};

export const ALL_GROUPS: NavigationGroup[] = [
  "pages",
  "collections",
  "products",
  "articles",
];

export const STANDALONE_ITEMS: NavigationItem[] = [
  { title: "Home", path: "/", group: STANDALONE_GROUP },
];
